function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  width: 112.196,
  height: 112.196,
  rx: 20,
  ry: 20,
  fill: "#3b5998"
});

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "matrix(0.7,0,0,0.7,16.829399871826176,16.829399871826176)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 56.098,
  cy: 56.098,
  r: 56.098,
  fill: "#3b5998"
}), /*#__PURE__*/React.createElement("path", {
  d: "M70.201,58.294h-10.01v36.672H45.025V58.294h-7.213V45.406h7.213v-8.34   c0-5.964,2.833-15.303,15.301-15.303L71.56,21.81v12.51h-8.151c-1.337,0-3.217,0.668-3.217,3.513v7.585h11.334L70.201,58.294z",
  fill: "#ffffff"
}));

function SvgFacebookShare({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 112.196 112.196",
    xmlSpace: "preserve",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgd2lkdGg9IjUxMiIgaGVpZ2h0PSI1MTIiIHg9IjAiIHk9IjAiIHZpZXdCb3g9IjAgMCAxMTIuMTk2IDExMi4xOTYiIHhtbDpzcGFjZT0icHJlc2VydmUiID4KICA8cmVjdCB3aWR0aD0iMTEyLjE5NiIgaGVpZ2h0PSIxMTIuMTk2IiByeD0iMjAiIHJ5PSIyMCIgZmlsbD0iIzNiNTk5OCIgLz4KICA8ZyB0cmFuc2Zvcm09Im1hdHJpeCgwLjcsMCwwLDAuNywxNi44MjkzOTk4NzE4MjYxNzYsMTYuODI5Mzk5ODcxODI2MTc2KSI+Cgk8Y2lyY2xlIGN4PSI1Ni4wOTgiIGN5PSI1Ni4wOTgiIHI9IjU2LjA5OCIgZmlsbD0iIzNiNTk5OCIvPgogIDxwYXRoCiAgICAgICAgZD0iTTcwLjIwMSw1OC4yOTRoLTEwLjAxdjM2LjY3Mkg0NS4wMjVWNTguMjk0aC03LjIxM1Y0NS40MDZoNy4yMTN2LTguMzQgICBjMC01Ljk2NCwyLjgzMy0xNS4zMDMsMTUuMzAxLTE1LjMwM0w3MS41NiwyMS44MXYxMi41MWgtOC4xNTFjLTEuMzM3LDAtMy4yMTcsMC42NjgtMy4yMTcsMy41MTN2Ny41ODVoMTEuMzM0TDcwLjIwMSw1OC4yOTR6IgogICAgICAgIGZpbGw9IiNmZmZmZmYiIC8+CjwvZz4KPC9zdmc+Cg==";
export { SvgFacebookShare as ReactComponent };